import styled from 'styled-components';
import { withTheme } from '@canopysecurity/component-library';
import {
  ParagraphText,
  SectionTitleText,
} from '../../StyledComponents/Typography';
import { HomeBaseTableRow, TableRows } from '../../StyledComponents/Table';
import React from 'react';
import { useFormattedDate } from './useFormattedDate';

const TableContainer = styled.div`
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  padding: 1% 2% 1% 2%;
  height: 80%;
  overflow-y: hidden;
`;
const TableRow = styled(HomeBaseTableRow)`
  grid-template-columns: 25fr 25fr;
`;

const TableHeaderRow = withTheme(styled(TableRow)`
  display: grid;
  background-color: ${({ theme }) => theme.background.main};
`);

interface DeploymentState {
  status: string;
  updatedAt: string;
}

interface DeviceDeploymentStatesTableProps {
  states: DeploymentState[];
  deploymentVersion: string;
  stateType: 'download' | 'install';
}
export const DeviceDeploymentStatesTable = (
  props: DeviceDeploymentStatesTableProps,
) => {
  const { states, deploymentVersion, stateType } = props;
  const { formattedDate } = useFormattedDate();
  return (
    <TableContainer>
      <TableHeaderRow>
        <SectionTitleText>Status</SectionTitleText>
        <SectionTitleText>Updated At</SectionTitleText>
      </TableHeaderRow>
      <TableRows>
        {states.map((state, index) => (
          <TableRow key={`${deploymentVersion}-${stateType}-${index}`}>
            <ParagraphText>{state.status}</ParagraphText>
            <ParagraphText>{formattedDate(state.updatedAt)}</ParagraphText>
          </TableRow>
        ))}
      </TableRows>
    </TableContainer>
  );
};
